import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TariffFreeBenefits, TariffZontProBenefits, } from 'console/billing/account-tariff/benefits';
import { RocketLaunch, Telegram } from '@mui/icons-material';
import { Box, Button, Card, CardActions, CardContent, CardHeader, Divider, Typography, } from '@mui/material';
import { grey } from '@mui/material/colors';
import { format_price_x100 } from 'console/billing/billing-utils';
import { AccountTariff } from 'console/billing/account-tariff/types';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
export function TariffCard({ description, isCurrent, isUpgrade, onChoose, }) {
    let benefits;
    let icon;
    let header_color = grey[400];
    switch (description.id) {
        case AccountTariff.free:
            benefits = _jsx(TariffFreeBenefits, {});
            icon = _jsx(Telegram, {});
            header_color = grey[400];
            break;
        case AccountTariff.zont_pro:
            benefits = _jsx(TariffZontProBenefits, {});
            icon = _jsx(RocketLaunch, {});
            header_color = 'primary.dark';
            break;
        default:
            benefits = (_jsx("div", { children: _jsx("i", { children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0442\u0430\u0440\u0438\u0444\u0430" }) }));
    }
    return (_jsxs(Card, { variant: "outlined", sx: {
            height: isMediumUI() ? '100%' : '580px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: isMediumUI() ? '50%' : '100%',
        }, children: [_jsx(CardHeader, { sx: {
                    color: 'common.white',
                    bgcolor: header_color,
                    p: 1,
                }, title: _jsxs(Box, { display: "flex", alignItems: "center", ml: 1, gap: 1, children: [icon, _jsx(Typography, { variant: "h5", fontSize: "120%", children: description.title })] }) }), _jsx(Divider, {}), _jsx(CardContent, { sx: { flexGrow: 1 }, children: _jsxs(Box, { display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%", children: [benefits, _jsxs(Typography, { sx: {
                                textAlign: 'center',
                                fontSize: '130%',
                            }, color: "primary", children: [format_price_x100(description.month_price_x100), " / \u043C\u0435\u0441\u044F\u0446"] })] }) }), _jsx(CardActions, { sx: { display: 'flex', justifyContent: 'center' }, children: isCurrent ? (_jsx(Button, { disabled: true, children: "\u0412\u0430\u0448 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0442\u0430\u0440\u0438\u0444" })) : (_jsxs(Button, { variant: isUpgrade ? 'contained' : 'text', color: "primary", onClick: onChoose, children: ["\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 ", description.title] })) })] }));
}
